module.exports = __webpack_public_path__ + "img/1071598101.0e472b93.jpg";